import type {
    GetShippingComplaintDataApiResponse,
    SaveShippingComplaintDataApiRequest,
    SaveShippingComplaintDataApiResponse,
} from './types/webapi-mytradera-generated';
import { isServer } from 'tradera/utils/nextjs';
import { createApi } from '@reduxjs/toolkit/query/react';
import { isomorphicWebApiBaseQuery } from './utils/webapi-base-query';

export const shippingComplaintApi = createApi({
    reducerPath: 'shippingComplaintApi',
    baseQuery: isomorphicWebApiBaseQuery,
    endpoints: (builder) => ({
        getShippingComplaintData: builder.query<
            GetShippingComplaintDataApiResponse,
            string
        >({
            query: (shipmentId) => {
                const urlParameters = new URLSearchParams({
                    shipmentId,
                });

                const baseUrl = isServer ? '' : '/api/webapi';
                return `${baseUrl}/mytradera/shipping/get-shipping-complaint-data?${urlParameters}`;
            },
        }),
        saveShippingComplaintData: builder.mutation<
            SaveShippingComplaintDataApiResponse,
            SaveShippingComplaintDataApiRequest
        >({
            query: (request) => ({
                url: '/api/webapi/mytradera/shipping/save-shipping-complaint-data',
                method: 'POST',
                body: request,
            }),
            onQueryStarted: async (request, { dispatch, queryFulfilled }) => {
                const patchResult = dispatch(
                    shippingComplaintApi.util.updateQueryData(
                        'getShippingComplaintData',
                        request.shipmentId,
                        (cache) => {
                            // eslint-disable-next-line better-mutation/no-mutation
                            cache.formData = request.formData;
                        },
                    ),
                );
                try {
                    const response = await queryFulfilled;
                    dispatch(
                        shippingComplaintApi.util.updateQueryData(
                            'getShippingComplaintData',
                            request.shipmentId,
                            (cache) => {
                                if (!cache.formData) return;
                                // eslint-disable-next-line better-mutation/no-mutation
                                cache.submittedDate =
                                    response.data.submittedDate;
                            },
                        ),
                    );
                } catch {
                    patchResult.undo();
                }
            },
        }),
    }),
});

export const {
    useGetShippingComplaintDataQuery,
    useSaveShippingComplaintDataMutation,
    endpoints,
} = shippingComplaintApi;
